import React from 'react'

const Footer = () => {
  return (
    <footer>
        <div>
            <h1>TechyStar</h1>
            <p>@all right reserved</p>
        </div>

        <div>
            <h5>Follow Us</h5>
            <div>
                <a href='https://youtube.com' target={'blank'}>Youtube</a>
                <a href='https://instagram.com' target={'blank'}>Instagram</a>
                <a href='https://github.com/DashNikhil/' target={'blank'}>Github</a>
            </div>
        </div>
    </footer>
  )
}

export default Footer;